import { Button, Col, Form, Row, Upload } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { Formik } from 'formik';
import FileUploadWithThumbnails from '../../LoanApplication/FileUploadWithThumbnails';

const VehicleDocuments = ({ updateFunction, vehicleType }) => {
    const [vehicelDocuments, setVehicleDocuments] = useState({});
    const [loanType, setLoanType] = useState('');
    const [vehicleLoanTypeData, setVehicleLoanTypeData] = useState('');

    return (
        <div>
            <Formik initialValues={vehicelDocuments} onSubmit={(values, { setSubmitting }) => { }}>
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                    <Form layout="vertical" onSubmit={handleSubmit}>
                        {vehicleType != 'New' &&
                            <Row gutter={[16, 16]}>
                                <FileUploadWithThumbnails label={"Logcard"} maxfile={2} size={6} datakey={'vehicle_details'} dataApiKey={'log_card'} updateFunction={updateFunction} />
                                <FileUploadWithThumbnails label={"Sales Agreement"} maxfile={2} size={6} datakey={'vehicle_details'} dataApiKey={'sale_agreement'} updateFunction={updateFunction} />
                                <FileUploadWithThumbnails label={"Additional Documents"} maxfile={6} size={8} datakey={'vehicle_details'} dataApiKey={'additional_documents'} updateFunction={updateFunction} />
                            </Row>
                        }
                        {(vehicleType == 'New') &&
                            <Fragment>
                                <Row gutter={[16, 16]}>
                                    <FileUploadWithThumbnails label={"V5/Overseas Logcard"} maxfile={2} size={6} datakey={'vehicle_details'} dataApiKey={'vehicle_overseas_log_card'} updateFunction={updateFunction} />
                                    <FileUploadWithThumbnails label={"Sales Agreement"} maxfile={2} size={6} datakey={'vehicle_details'} dataApiKey={'sale_agreement'} updateFunction={updateFunction} />
                                    <FileUploadWithThumbnails label={"Datacard"} maxfile={6} size={8} datakey={'vehicle_details'} dataApiKey={'data_card'} updateFunction={updateFunction} />
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <FileUploadWithThumbnails label={"Cargo Clearance Permit:"} maxfile={2} size={6} datakey={'vehicle_details'} dataApiKey={'cargo_clearance_permits'} updateFunction={updateFunction} />
                                    <FileUploadWithThumbnails label={"Bill of Lading (BL): "} maxfile={2} size={6} datakey={'vehicle_details'} dataApiKey={'bill_of_lading'} updateFunction={updateFunction} />
                                    <FileUploadWithThumbnails label={"Letter of Newness: "} maxfile={6} size={8} datakey={'vehicle_details'} dataApiKey={'letter_of_newness'} updateFunction={updateFunction} />
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <FileUploadWithThumbnails label={"Additional Documents"} maxfile={6} size={8} datakey={'vehicle_details'} dataApiKey={'additional_documents'} updateFunction={updateFunction} />
                                </Row>
                            </Fragment>
                        }
                    </Form>
                )}
            </Formik>
        </div >
    );
};

export default VehicleDocuments;